import { createContext, Dispatch } from 'react';

import { ErrorSnackbarAction } from './types';

export const ErrorSnackbarContext = createContext<Dispatch<ErrorSnackbarAction>>(() => {});
